import { render, staticRenderFns } from "./RuKuGBRecord.vue?vue&type=template&id=44781256&"
import script from "./RuKuGBRecord.vue?vue&type=script&lang=js&"
export * from "./RuKuGBRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports